<template>
  <div class="detail-wrapper">
    <div class="prodet-bg">
      <div class="container" style="overflow: hidden">
        <div class="por-box-location" ref="videoTop" data-key="0">
          <Icon custom="ich-icon ich-icon-map" size="18" />
          <span>
            {{ courseInfo.courseName }} | 包含班级：
            <span>正在播放</span>
            {{ currentSpecial.specialName }}
          </span>
          <div
            style="display: inline; cursor: pointer"
            v-if="isShowTrans"
            @click="beforeTransSerect"
          >
            <span style="color: #ffff00">最新《考前密训班资料》点击领取</span>
            <span style="color: #ffff00">>></span>
          </div>
        </div>
        <div class="por-box-b">
          <div
            :title="item.specialName"
            class="por-boxb-a"
            :class="{ selected: currentSpecial.cstId === item.cstId }"
            v-for="(item, index) in specialList
              .filter((m) => m.type === 1 || m.type === 2)
              .slice(0, 8)"
            :key="index"
            @click="changeCourseSpecial(item)"
          >
            <span class="por-boxb-title">{{ item.specialName }}</span>
            <div class="por-boxb-expire" v-if="item.isExpire === 1">
              <img src="../../assets/images/mall/special-expire.png" />
            </div>
            <div class="can-live" v-if="item.hasLive">包含直播</div>
          </div>
          <div class="por-boxb-b" v-show="specialList.length > 8">
            <div class="por-boxb-title">
              <span>全部班型</span>
              <Icon type="md-arrow-dropdown" size="16" />
            </div>

            <ul class="por-boxb-list">
              <li
                v-for="(item, index) in specialList.filter(
                  (m) => m.type === 1 || m.type === 2
                )"
                :key="index"
              >
                <a :title="item.specialName" @click="changeCourseSpecial(item)">
                  {{ item.specialName }}
                </a>
              </li>
            </ul>
          </div>
          <!-- <div class="pro-selecat">
            <Select v-model="modelOfSelect" style="width: 200px" @on-change="seled">
              <OptionGroup label="我的课程">
                <Option
                  v-for="item in cityList1"
                  :value="item.courseId"
                  :key="item.courseId"
                >
                  <router-link
                    :to="{ name: 'CourseStudy', params: { cid: item.courseId } }"
                  >
                    {{ item.courseName }}
                  </router-link>
                </Option>
              </OptionGroup>
              <OptionGroup label="已学课程">
                <Option
                  v-for="item in cityList2"
                  :value="item.courseId"
                  :key="item.courseId"
                >
                  <router-link
                    :to="{ name: 'CourseStudy', params: { cid: item.courseId } }"
                  >
                    {{ item.courseName }}
                  </router-link>
                </Option>
              </OptionGroup>
            </Select>
          </div> -->
        </div>
        <div class="prodet-player clearfix">
          <div class="prodet-player-lock" v-if="currentSpecial.isExpire === 1">
            <div
              v-if="routeModel == 1"
              class="podet-player-lock-icon"
              @click="buyModelVisible = true"
            >
              <Icon type="ios-lock" />
              <p>课程班型已过期</p>
            </div>
            <div v-else class="podet-player-lock-icon">
              <Icon type="ios-lock" />
              <p>课程班型已过期</p>
            </div>
          </div>
          <div class="prodet-box-c">
            <div
              v-if="subtitleShow"
              class="ivu-alert ivu-alert-warning ivu-alert-with-icon"
              style="
                position: absolute;
                left: 0;
                top: 0;
                width: 100%;
                z-index: 100;
              "
            >
              <span class="ivu-alert-icon"
                ><i
                  class="ivu-icon ivu-icon-ios-alert"
                  style="line-height: 1.2"
                ></i
              ></span>
              <span class="ivu-alert-message"
                >视频提供AI翻译字幕，使用时请谨慎核实，避免误解。感谢您的理解与支持！</span
              >
              <span class="ivu-alert-desc"></span>
              <a class="ivu-alert-close" @click="subtitleShow = false">
                <i class="ivu-icon ivu-icon-ios-close"> </i
              ></a>
            </div>
            <video-player
              v-if="currentSpecial.type === 1"
              :width="800"
              :viewId="umcId"
              viewType="ppt"
              @on-over="playOver"
              @on-start="playStart"
              @ready="handleSubtitle"
              :loading="!isLoaded"
              page="study"
            ></video-player>
            <video-player
              v-else
              :width="800"
              :viewId="viewId"
              viewType="review"
              @on-over="playOver"
              @ready="handleSubtitle"
              :loading="!isLoaded"
              page="study"
              :tipText="noVideoText"
            ></video-player>
          </div>
          <div class="prodet-box-d clearfix">
            <div class="prodet-boxd-a">
              <course-catalog v-if="currentSpecial.type === 1"></course-catalog>
              <review-catalog
                page="study"
                :is-course-study="$route.name === 'CourseStudy'"
                v-if="currentSpecial.type === 2"
                @change="changeCatalog"
              ></review-catalog>
            </div>
            <div class="prodet-boxd-b">
              <div class="prodet-pt-a active">
                <Icon custom="ich-icon ich-icon-catalog" />
                <p>视频</p>
              </div>
              <div class="prodet-pt-a" @click="scrollView(tabList[2])">
                <Icon custom="ich-icon ich-icon-exercise" />
                <p>题库</p>
              </div>
              <div
                class="prodet-pt-a"
                @click="scrollView(tabList[3])"
                v-show="isExistVideo && siteConfig.isQa === 1"
              >
                <Icon custom="ich-icon ich-icon-question" />
                <p>课程提问</p>
              </div>
              <template v-if="isBuy">
                <div class="prodet-pt-a">
                  <router-link
                    :to="{ name: 'WrongBook', params: { id: umcId } }"
                    taget="_blank"
                  >
                    <Icon custom="ich-icon ich-icon-wrong-book" />
                    <p>错题本</p>
                  </router-link>
                </div>
                <div class="prodet-pt-a">
                  <router-link
                    :to="{ name: 'FavExercise', params: { id: umcId } }"
                    taget="_blank"
                  >
                    <Icon custom="ich-icon ich-icon-fav-exercise" />
                    <p>习题收藏</p>
                  </router-link>
                </div>
                <div class="prodet-pt-a" v-show="isExistVideo">
                  <router-link
                    :to="{ name: 'FavVideo', params: { id: umcId } }"
                    taget="_blank"
                  >
                    <Icon custom="ich-icon ich-icon-fav-video" />
                    <p>视频收藏</p>
                  </router-link>
                </div>
              </template>
              <div class="prodet-pt-a" v-if="isBuy">
                <router-link
                  :to="{ name: 'CourseWare', query: { cid: courseId } }"
                >
                  <Icon custom="ich-icon ich-icon-download" />
                  <p>课件资料</p>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 操作区域 -->
      <div class="container prodet-action clearfix">
        <div class="prodet-box-e" v-show="isBuy && isExistVideo">
          <router-link
            :to="{
              name: 'VideoPractice',
              params: { id: courseId },
              query: { catid: catalogId, umcid: umcId },
            }"
            target="_blank"
          >
            <Button
              type="primary"
              shape="circle"
              size="large"
              style="width: 120px; line-height: 40px; margin-right: 30px"
              v-show="isVideoPractice && currentSpecial.type === 1"
            >
              课后练习
            </Button>
          </router-link>
          <span
            style="margin-right: 30px"
            :class="{ active: isFavorite }"
            @click="setVideoFav"
          >
            <Icon custom="ich-icon ich-icon-fav" size="18" />
            <abbr v-if="isFavorite">取消收藏</abbr>
            <abbr v-else>收藏视频</abbr>
          </span>
          <span style="margin-right: 30px">
            <Icon custom="ich-icon ich-icon-play-rectangle" size="18" />
            播放
            <b class="color2">{{ videoPlayTimes }}</b>
            次
          </span>
        </div>
      </div>
    </div>

    <div class="container clearfix">
      <!-- 各类详情 -->
      <div class="product-detail">
        <div class="product-info-bar" ref="courseTop" data-key="1">
          课程介绍
        </div>
        <h3 class="product-info-title">
          {{ courseInfo.courseName }}
        </h3>
        <ul class="product-info-body">
          <li>
            <div class="info-item">
              <span>•</span>
              课程代码：
            </div>
            <div class="info-content">{{ courseInfo.courseNo }}</div>
          </li>
          <li></li>
          <li>
            <div class="info-item">
              <span>•</span>
              所属地区：
            </div>
            <div class="info-content">
              <em v-for="(item, index) in courseInfo.provinceList" :key="index">
                {{ item.name }} &nbsp;
              </em>
            </div>
          </li>
          <li>
            <div class="info-item">
              <span>•</span>
              考试时间：
            </div>
            <div class="info-content">
              <template
                v-if="
                  courseInfo.examTimeList && courseInfo.examTimeList.length > 0
                "
              >
                <p
                  v-for="(item, index) in courseInfo.examTimeList"
                  :key="index"
                >
                  <span>{{ item.province ? item.province : "------" }}</span>
                  <span style="margin-left: 30px">{{ item.examDate }}</span>
                  <span style="margin-left: 10px">
                    {{ item.startTime }}-{{ item.endTime }}
                  </span>
                </p>
              </template>
              <p v-else>待确定</p>
            </div>
          </li>
        </ul>
        <h4 class="product-info-sub">包含班型：</h4>
        <div class="product-course-list">
          <dl>
            <dd v-for="(special, speIndex) in specialList" :key="speIndex">
              {{ special.specialName }}
            </dd>
          </dl>
        </div>

        <h4 class="product-info-sub">包含课程视频：</h4>
        <ul
          class="product-info-body col1"
          v-if="courseInfo.courseSpecialTypesByCourse"
        >
          <li v-for="(item, index) in specialStatisticsWithVideo" :key="index">
            <div class="info-item">
              <span>•</span>
              {{ item.specialName }}：
            </div>
            <div class="info-content">
              <span>
                课时：
                <b class="color2">{{ item.pptTime }}</b>
                分钟
              </span>
              <span>
                视频：
                <b class="color2">{{ item.pptNum }}</b>
                个
              </span>
              <span v-if="siteConfig.isShowProductValid == 1">
                有效期：{{ item.endTime }}
              </span>
            </div>
          </li>
        </ul>

        <h4 class="product-info-sub">包含课程题库：</h4>
        <ul
          class="product-info-body col1"
          v-if="courseInfo.courseSpecialTypesByCourse"
        >
          <li
            v-for="(item, index) in specialStatisticsWithExercise"
            :key="index"
          >
            <div class="info-item">
              <span>•</span>
              {{ item.specialName }}：
            </div>
            <!-- <div v-if="item.specialType === 3" class="info-content">
              <span
                ><b class="color2">{{ item.exerNum }}</b> 题</span
              >
            </div> -->
            <div v-if="item.specialType === 4" class="info-content">
              <span>
                <b class="color2">{{ item.simExamAmountNum }}</b>
                题
                <b class="color2">{{ item.simExamItem }}</b>
                套
              </span>
              <span v-if="siteConfig.isShowProductValid == 1">
                有效期：{{ item.endTime }}
              </span>
            </div>
            <div v-else class="info-content">
              <span>
                <b class="color2">{{ item.exerNum }}</b>
                题
              </span>
              <span v-if="siteConfig.isShowProductValid == 1">
                有效期：{{ item.endTime }}
              </span>
            </div>
          </li>
        </ul>
        <h4 class="product-info-sub">使用教材</h4>
        <div class="product-info-textbook">
          <div
            v-for="item in courseInfo.tchMaterialList"
            :key="item.courseId"
            class="product-info-center"
          >
            <div class="textbook-img">
              <img
                :src="concatImageUrl(item.coverPic, 68, 98)"
                alt="教材名称"
                style="width: 68px; height: 98px"
                v-if="item.coverPic"
              />
              <img v-else src="../../assets/images/v3/material-default.png" />
            </div>
            <div class="textbook-info">
              <div class="textbook-name">
                <Tooltip
                  :content="`《${item.matName}》`"
                  max-width="400"
                  placement="top-start"
                >
                  <div class="textbook-name-in">《{{ item.matName }}》</div>
                </Tooltip>
              </div>
              <span>
                <b>主编：</b>
                {{ item.writer }}
              </span>
              <br />
              <span>
                <b>版次：</b>
                {{ item.pubNo }}
              </span>
              <span>
                <b>出版社：</b>
                {{ item.pubName }}
              </span>
            </div>
            <div class="product-info-line"></div>
          </div>
        </div>
        <div
          style="padding-top: 20px; font-size: 16px; line-height: 30px"
          v-html="courseInfo.brief"
        ></div>
      </div>
      <!-- 侧边栏 -->
      <div class="product-sider">
        <div class="product-info-bar">师资简介</div>
        <teacher-slider :dataList="courseInfo.teacherList"></teacher-slider>
      </div>
    </div>
    <!-- 题库 -->
    <div class="study-module">
      <div class="product-info-bar" ref="exerciseTop" data-key="2">题库</div>
      <div class="product-info-bar-en">
        <img src="../../assets/images/v3/product-detail-title-en01.png" />
      </div>
      <exercise-store
        v-if="courseLoaded"
        :course="courseInfo"
        @on-expire="buyModelVisible = true"
      ></exercise-store>
    </div>

    <!-- 提问 -->
    <div class="study-module" v-show="isExistVideo && siteConfig.isQa === 1">
      <div class="product-info-bar" ref="questionTop" data-key="3">提问</div>
      <div class="product-info-bar-en">
        <img src="../../assets/images/v3/product-detail-title-en02.png" />
      </div>
      <question
        v-if="courseLoaded"
        :course="courseInfo"
        :specialType="currentSpecial"
      ></question>
    </div>
    <!-- 统计 -->
    <div class="study-module">
      <div class="product-info-bar" ref="statisticsTop" data-key="4">
        学习统计
      </div>
      <div class="product-info-bar-en">
        <img src="../../assets/images/v3/product-detail-title-en03.png" />
      </div>
      <study-statistics v-if="courseLoaded"></study-statistics>
    </div>

    <!-- 侧边栏导航 -->
    <div class="sider-nav" :class="{ 'put-away': !siderNavVisible }">
      <div class="pos" @click="switchSiderNav">
        <Icon v-if="siderNavVisible" type="ios-arrow-back" />
        <Icon v-else type="ios-arrow-forward" />
      </div>
      <div
        v-for="(item, index) in tabList"
        :key="index"
        class="nav-item"
        :class="{ selected: tabKey == item.key }"
        @click="scrollView(item)"
        v-show="item.key != 3 || (isExistVideo && siteConfig.isQa === 1)"
      >
        {{ item.name }}
      </div>
    </div>

    <Modal
      v-model="buyModelVisible"
      :closable="false"
      :mask-closable="false"
      width="360"
      class-name="vertical-center-modal"
    >
      <p slot="header" style="color: #f60; text-align: center">
        <Icon type="ios-information-circle"></Icon>
        <span style="margin-left: 0.5rem">友情提示</span>
      </p>
      <p>&nbsp;</p>
      <p style="text-align: center">您所选的课程班型已过期，是否前往购买！</p>
      <div slot="footer" style="text-align: center">
        <Button
          type="error"
          size="large"
          @click="buyModelVisible = false"
          style="margin-right: 30px"
        >
          继续学习
        </Button>
        <Button type="success" size="large" @click="buyProduct">
          购买课程
        </Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import VideoPlayer from "../../components/common/VideoPlayer";
import CourseCatalog from "./CourseCatalog";
import ReviewCatalog from "./ReviewCatalog";
import TeacherSlider from "./TeacherSlider";

import ExerciseStore from "./study/ExerciseStore";
import Question from "./study/Question";
import StudyStatistics from "./study/StudyStatistics";

import { siteMixin } from "../../utils/mixin";
import { mall, study } from "../../request";
import { saveBuyProduct } from "../../utils/localStorage";

export default {
  mixins: [siteMixin],
  data() {
    return {
      tabKey: 0,
      tabList: [
        {
          key: 0,
          name: "课程学习",
          top: 0,
        },
        {
          key: 1,
          name: "课程介绍",
          top: 700,
        },
        {
          key: 2,
          name: "题库",
          top: 0,
        },
        {
          key: 3,
          name: "提问",
          top: 0,
        },
        {
          key: 4,
          name: "学习统计",
          top: 0,
        },
      ],
      buyModelVisible: false,
      refreshComponent: true,
      umcrId: 0,
      viewId: 0,
      specialList: [],
      currentSpecial: {}, //当前班型
      noVideoText: "",
      courseInfo: {
        teacherList: [],
      },
      courseLoaded: false,
      specialStatisticsWithVideo: [],
      specialStatisticsWithExercise: [],
      isExistVideo: true,
      isVideoPractice: false,
      isFavorite: false,
      videoPlayTimes: 0,
      isLoaded: false,
      siderNavVisible: true,
      modelOfSelect: "",
      cityList1: [],
      cityList2: [],
      arrycity: [],
      isShowTrans: false,
      cstid: "",
      reviewid: "",
      subtitleShow: false,
      tchMaterialList: [],
    };
  },
  watch: {
    pptId() {
      console.log("sultan");
      this.getVideoIsFav();
      this.getPlayTimes();
    },
    catalogId() {
      this.getVideoPractice();
    },
  },
  mounted() {
    this.initCourseData();
    this.setViewScrollTab();
    this.getTransQuanlity();
    // this.getSelectedClasses();

    //定制化跳转的滚动处理
    const custom = this.$route.query.e;
    if (custom && custom == "x") {
      setTimeout(() => {
        this.scrollView(this.tabList[2]);
      }, 300);
    }
  },
  methods: {
    //获取下拉选择数据    this.loginUser.userId
    getSelectedClasses() {
      study.getselectdata(this.loginUser.userId, "").then((res) => {
        this.arrycity = res.data;
        res.data.map((item) => {
          if (item.umcOverdue == false) {
            this.cityList1.push(item);
          }
        });
        res.data.map((item) => {
          if (item.umcOverdue == true) {
            this.cityList2.push(item);
          }
        });
      });
    },

    seled(value) {
      window.location.reload();
    },

    initCourseData() {
      const courseId = this.$route.params.cid;
      //if(!courseId) this.$router.push(); 跳转到错误页
      this.setCourseId(courseId);
      this.getCourseSpecialType();
      this.getCourseInfo();
    },
    //获取用户课程班型
    getCourseSpecialType() {
      study
        .getCourseSpecial(this.courseId, this.loginUser.userId)
        //.getCourseSpecial("9-1241235r31513121", 14868)
        .then((res) => {
          //console.log("courseSpecial", res);
          if (res.status === 1) {
            if (res.data && res.data.length > 0) {
              this.specialList = res.data;

              //初始化默认班型数据（以有视频的优先，否则取第一个）
              // 解决模考题目umcId不一致问题
              const existVideoSpecial = this.specialList.find(
                (m) => m.needUmc && m.needUmc === 1
              );
              if (existVideoSpecial) {
                this.currentSpecial = existVideoSpecial;
              } else {
                this.currentSpecial = this.specialList[0];
              }
              this.setCourseSpecialId(this.currentSpecial.cstId);
              this.setUmcId(this.currentSpecial.umcId);
              this.getCourseCatalogWithStudy();

              // 只获取课程精讲班  并储存cid给章节练习使用
              let infoObj = this.specialList.find(
                (item) => item.SpecialId == 3
              );
              if (infoObj) {
                this.setDefaultCid(infoObj.umcId);
              } else {
                this.setDefaultCid(this.currentSpecial.umcId);
              }
            }
          }
        });
    },
    //获取课程信息，及用户是否购买过当前课程，以及获取课程目录
    getCourseInfo() {
      mall
        .getCourseInfo(
          this.courseId,
          this.loginUser.userId,
          this.siteConfig.agencyId
        )
        .then((res) => {
          //console.log("courseInfo", res);
          if (res.status === 1) {
            this.courseInfo = res.data;

            //处理班型统计数据
            if (this.courseInfo) {
              this.specialStatisticsWithVideo =
                this.courseInfo.courseSpecialTypesByCourse.filter(
                  (m) => m.specialType === 1
                );
              const a = this.courseInfo.courseSpecialTypesByCourse.filter(
                (m) => m.specialType === 3
              );
              const b = this.courseInfo.courseSpecialTypesByCourse.filter(
                (m) => m.specialType === 4
              );
              const c = this.courseInfo.courseSpecialTypesByCourse.filter(
                (m) => m.specialType === 2
              );
              this.specialStatisticsWithExercise = [...a, ...b, ...c];
            }
            this.setIsBuy(this.courseInfo.isBuy == 0 ? false : true);
            this.setMetaData(this.courseInfo.courseName);

            this.courseLoaded = true;
          }
        });
    },
    changeCourseSpecial(item) {
      if (item.cstId == this.currentSpecial.cstId) return;
      this.currentSpecial = item;
      this.setCourseSpecialId(this.currentSpecial.cstId);
      this.setUmcId(item.umcId);
      this.getCourseCatalogWithStudy();
      this.refreshComponent = false;
      this.$nextTick(() => {
        this.refreshComponent = true;
      });
    },
    changeCatalog(type) {
      if (type === "vod") {
        this.viewId = this.umcrId;
      } else {
        this.viewId = "u" + this.loginUser.userId;
      }
    },
    //获取课程目录（已购买，包括章节学习统计信息）
    getCourseCatalogWithStudy() {
      //this.isLoaded = false;
      study
        .getCourseCatalog(
          this.umcId,
          this.courseId,
          this.currentSpecial.cstId,
          this.currentSpecial.type,
          this.loginUser.userId,
          this.siteConfig.agencyId
        )
        .then((res) => {
          if (res.status === 1) {
            this.isLoaded = true;
            if (!res.data || res.data.length == 0) {
              this.setCourseCatalog([]);
              this.setPptId("");
              this.setVideoId("");
              this.isExistVideo = false;
              if (this.currentSpecial.type === 2) {
                this.noVideoText = "该班型视频正在准备中";
              }
            }
            //章节
            if (this.currentSpecial.type === 1) {
              this.setCourseCatalog(res.data);
              //查找并设置视频ID
              if (res.data.length > 0) {
                const one = res.data[0];
                if (one.childList && one.childList.length > 0) {
                  const two = one.childList[0];
                  if (two.childList && two.childList.length > 0) {
                    const three = two.childList[0];
                    if (three.isTryLook == 1) {
                      this.setPptId(three.pptId);
                      this.setVideoId(three.bVideoId);
                      this.setCatalogId(three.catId);
                      this.isExistVideo = true;
                    } else {
                      this.setPptId("");
                      this.setVideoId("");
                      this.isExistVideo = false;
                    }
                  }
                }
              }
            }
            //串讲
            if (
              this.currentSpecial.type === 2 &&
              res.data &&
              res.data.length > 0
            ) {
              this.umcrId = res.data[0].umcrId;
              this.viewId = this.umcrId;
              const reviewPptList = res.data[0].pptList || [];
              const liveList = res.data[0].live;
              let resultList = [];
              let current = null;
              if (reviewPptList && reviewPptList.length) {
                resultList = reviewPptList.map((m) => {
                  return {
                    type: 1,
                    ...m,
                  };
                });
                current = reviewPptList[0];
              } else {
                this.viewId = "u" + this.loginUser.userId;
              }
              if (liveList && liveList.length) {
                const liveTemp = liveList.map((m) => {
                  return {
                    type: 2,
                    isTryLook: 0,
                    ...m,
                  };
                });
                resultList = [...resultList, ...liveTemp];
                if (!current) {
                  const { isLook, videoId, title } = liveList[0];
                  current = {
                    ...liveList[0],
                    isTryLook: isLook,
                    // PvideoID: videoId,
                    bVideoId: videoId,
                    PptName: title,
                    PptId: 0,
                  };
                }
              }
              if (resultList && resultList.length) {
                this.setReviewCatalog(resultList);
                if (current && current.isTryLook === 1) {
                  this.setPptId(current.PptId);
                  this.setVideoId(current.bVideoId);
                  this.setReviewPositionName(current.PptName);
                  if (!this.videoId) {
                    this.setVideoId("onlyLive");
                  }
                } else {
                  this.setPptId("");
                  this.setVideoId("");
                  this.isExistVideo = false;
                }
              } else {
                this.setPptId("");
                this.setVideoId("");
                this.isExistVideo = false;
                if (this.currentSpecial.SpecialId == 52) {
                  this.noVideoText =
                    "当前班型录播视频未上线，请切换班型或进入“我的直播”观看课程直播";
                } else {
                  this.noVideoText = "该班型视频正在准备中";
                }
              }
            }
          }
        });
    },
    //获取视频是否收藏
    getVideoIsFav() {
      if (this.isBuy && this.umcId > 0 && this.pptId > 0) {
        study.getVideoIsFav(this.umcId, this.pptId).then((res) => {
          if (res.status === 1) {
            this.isFavorite = res.data == 1;
          }
        });
      }
    },
    //[取消]收藏视频
    setVideoFav() {
      study
        .addOrDelVideoFav(
          this.umcId,
          this.pptId,
          this.loginUser.userId,
          this.courseId
        )
        .then((res) => {
          if (res.status === 1) {
            this.isFavorite = !this.isFavorite;
          } else {
            this.$Message.error(res.message);
          }
        });
    },
    //获取播放次数
    getPlayTimes() {
      if (
        this.umcId > 0 &&
        this.currentSpecial.type == 1 &&
        this.catalogId > 0
      ) {
        study.getVideoPlayInfo(this.umcId, this.catalogId).then((res) => {
          //console.log(res);
          if (res.status === 1) {
            this.videoPlayTimes = res.data[0].pptTimes;
          }
        });
      }
      if (this.umcId > 0 && this.currentSpecial.type == 2 && this.umcrId > 0) {
        study.getReviewPlayInfo(this.umcrId, this.pptId).then((res) => {
          //console.log("reviewPlayTimes", res);
          if (res.status === 1) {
            this.videoPlayTimes = res.data.pptTimes;
          }
        });
      }
    },
    getVideoPractice() {
      if (this.isBuy && this.umcId > 0 && this.catalogId > 0) {
        study.getVideoExerList(this.umcId, this.catalogId).then((res) => {
          //console.log(res);
          if (res.status === 1) {
            this.isVideoPractice = res.data.length > 0;
          }
        });
      }
    },
    playStart() {
      console.log("videoStart", this.umcId, this.catalogId);
      console.log(this.playList);
      if (this.currentSpecial.type === 1) {
        study
          .setVideoPlayOverWithPpt(this.umcId, this.catalogId)
          .then((res) => {
            console.log("videoStartEnd", res);
            console.log("根据，机构ID来清除视频list");

            // 3328  4048  4126
            const agency = this.siteConfig.agencyId;
            if (agency == "3328" || agency == "4048" || agency == "4126") {
              this.setPlayList([]);
            }
            // this.setPlayList([]);
          });
      }
    },
    playOver() {
      console.log("playOver", this.umcId, this.catalogId);
      if (this.currentSpecial.type === 1) {
        study
          .setVideoPlayOverWithPpt(this.umcId, this.catalogId, 1)
          .then((res) => {
            console.log("playOverEnd", res);
          });
      }
      //串讲
      if (this.currentSpecial.type === 2) {
        study
          .setVideoPlayOverWithReview(this.umcrId || 0, this.pptId)
          .then((res) => {
            console.log(res);
          });
      }
    },
    buyProduct() {
      if (this.courseId) {
        this.$router.push({
          name: "ProductList",
          query: { k: this.courseId },
        });
      }
    },
    scrollView(item) {
      this.tabKey = item.key;
      this.setViewTop();
      //alert(item.top);
      this.clickScroll = true;
      this.currentScrollTop = document.documentElement.scrollTop;
      this.targetScrollTop = item.top;
      window.scroll({ top: item.top, behavior: "smooth" });
    },
    setViewTop() {
      const fixTop = 100;
      const scrollTop = document.documentElement.scrollTop;
      const exerciseTop = this.$refs.exerciseTop.getBoundingClientRect();
      let questionTop = null;
      if (this.isExistVideo && this.siteConfig.isQa === 1) {
        questionTop = this.$refs.questionTop.getBoundingClientRect();
      }
      const statisticsTop = this.$refs.statisticsTop.getBoundingClientRect();
      this.tabList.forEach((item, index) => {
        if (item.key === 2) {
          item.top = exerciseTop.top + scrollTop - fixTop;
        }
        if (item.key === 3 && questionTop) {
          item.top = questionTop.top + scrollTop - fixTop;
        }
        if (item.key === 4) {
          item.top = statisticsTop.top + scrollTop - fixTop;
        }
      });
    },
    getScrollTop() {
      return;
    },
    setViewScrollTab() {
      const fixTop = 300;
      this.tabKey = false;
      this.tabKey = 0;
      window.onscroll = () => {
        let videoTop = this.$refs.videoTop.getBoundingClientRect().top;
        let courseTop = this.$refs.courseTop.getBoundingClientRect().top;
        let exerciseTop = this.$refs.exerciseTop.getBoundingClientRect().top;
        let questionTop = -1;
        if (this.$refs.questionTop) {
          questionTop = this.$refs.questionTop.getBoundingClientRect().top;
        }
        let statisticsTop =
          this.$refs.statisticsTop.getBoundingClientRect().top;
        let tabScrollKey = 0;
        if (videoTop < fixTop) {
          tabScrollKey = 0;
        }
        if (courseTop < fixTop) {
          tabScrollKey = 1;
        }
        if (exerciseTop < fixTop) {
          tabScrollKey = 2;
        }
        if (questionTop != -1 && questionTop < fixTop) {
          tabScrollKey = 3;
        }
        if (statisticsTop < fixTop) {
          tabScrollKey = 4;
        }
        //console.log(this.clickScroll);

        //定位标识处理
        if (!this.clickScroll) {
          this.tabKey = tabScrollKey;
        }
        let scrollTop = document.documentElement.scrollTop;
        let bodyHeight = document.body.scrollHeight;
        if (typeof this.targetScrollTop != "undefined" && this.clickScroll) {
          //this.targetScrollTop += 100;
          let isUp =
            this.currentScrollTop > this.targetScrollTop ||
            this.targetScrollTop == 0;
          let isDown = this.currentScrollTop < this.targetScrollTop;

          if (isDown && this.targetScrollTop <= scrollTop) {
            this.tabKey = tabScrollKey;
            this.clickScroll = false;
          }
          if (isUp && this.targetScrollTop >= scrollTop) {
            this.tabKey = tabScrollKey;
            this.clickScroll = false;
          }
        }
      };
    },
    switchSiderNav() {
      this.siderNavVisible = !this.siderNavVisible;
    },
    //  获取考前密训链接资格
    getTransQuanlity() {
      const courseId = this.$route.params.cid;
      mall
        .getTraningQuanlification(courseId, this.loginUser.userId)
        .then((res) => {
          console.log("res", res);
          if (res.data?.secret == 1) {
            this.isShowTrans = true;
          }
          this.cstid = res.data?.cstid;
          this.reviewid = res.data?.reviewid;
        });
    },
    // 考前密训跳转
    beforeTransSerect() {
      this.$router.push({
        name: "BeforeTransSecret",
        params: {
          cstid: this.cstid,
          reviewid: this.reviewid,
        },
      });
    },
    handleSubtitle(player) {
      // console.log('palyer.subtitle.on', player.subtitle.on)
      this.subtitleShow = player.options.videoInfo.subtitles.length > 0;
    },
  },
  components: {
    VideoPlayer,
    CourseCatalog,
    ReviewCatalog,
    TeacherSlider,
    ExerciseStore,
    Question,
    StudyStatistics,
  },
};
</script>

<style lang="less" scoped>
@import "../../assets/css/var.less";
.detail-wrapper {
  background: url("../../assets/images/v3/product-detail-bg.png") repeat-y
    center top;
}
//播放位置
.prodet-bg {
  background: #2f3133 url("../../assets/images/v3/player-bg-p.png") repeat-y
    center bottom;
  width: 100%;
  padding-top: 70px;
  .por-box-location {
    height: 70px;
    line-height: 70px;
    color: #999;
    font-size: 16px;
    i {
      vertical-align: -0.08em;
    }
    span {
      .inline-block();
      margin-left: 10px;
      & > span {
        height: 26px;
        line-height: 26px;
        padding: 0 12px;
        border-radius: 4px;
        vertical-align: 0.08em;
        .background-primary();
      }
    }
  }
  .por-box-b {
    width: 100%;
    height: 50px;
    background: #1b1b1b;

    .pro-selecat {
      color: #fff;
      float: right;
      height: 50px;
      display: flex;
      align-items: center;
    }
    .por-boxb-a {
      position: relative;
      width: 130px;
      height: 50px;
      font-size: 16px;
      text-align: center;
      float: left;
      border-right: 1px solid #272727;
      margin-left: -1px;
      &:hover,
      &.selected {
        .background-primary();
      }
      .por-boxb-title {
        display: block;
        width: 100%;
        height: 50px;
        line-height: 50px;
        color: white;
        .ellipsis();
        padding: 0 10px;
        cursor: pointer;
      }
      .por-boxb-expire {
        position: absolute;
        right: 0;
        top: -20px;
      }
      .can-live {
        position: absolute;
        top: -8px;
        left: 4px;
        width: 70px;
        height: 20px;
        line-height: 20px;
        background-color: #e73d2e;
        color: #fff;
        font-weight: bold;
        border-radius: 3px;
        font-size: 12px;
        text-align: center;
      }
    }
    .por-boxb-b {
      float: right;
      text-align: center;
      position: relative;
      height: 50px;
      padding-right: 12px;
      .por-boxb-title {
        margin-top: 8px;
        height: 36px;
        line-height: 34px;
        border: 1px solid #bbbbbb;
        background-color: #4e4e4e;
        color: white;
        font-size: 14px;
        cursor: pointer;
        padding-right: 5px;
        span {
          width: 100px;
          padding-left: 5px;
          .inline-block();
          .ellipsis();
        }
      }
      .por-boxb-list {
        position: absolute;
        background-color: #1b1b1b;
        width: 325px;
        top: 60px;
        right: -325px;
        height: 500px;
        z-index: 100;
        overflow-y: auto;
        .transTime(0.2s);
        li {
          height: 50px;
          line-height: 50px;
          width: 100%;
          padding: 0 20px;
          &:hover,
          &.selected {
            .background-primary();
          }
          & > a {
            display: block;
            color: #fff;
            text-align: left;
            font-size: 16px;
            .ellipsis();
          }
        }
      }
      &:hover {
        .por-boxb-title {
          border: 1px solid transparent;
          background: linear-gradient(to right, #349eee, #6f98f9);
        }
        .por-boxb-list {
          right: 0;
        }
      }
    }
  }
  .prodet-player {
    width: 100%;
    position: relative;
    .prodet-player-lock {
      position: absolute;
      left: 0;
      right: 0;
      width: 1125px;
      height: 100%;
      background: rgba(0, 0, 0, 0.9);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 500;
      .podet-player-lock-icon {
        font-size: 60px;
        color: #fff;
        text-align: center;
        p {
          font-size: 20px;
        }
      }
    }
    .prodet-box-c {
      position: relative;
      float: left;
      width: 800px;
      height: 500px;
      background: #e4ebef;
    }
    .prodet-box-d {
      float: left;
      width: 400px;
      height: 500px;
      background: #1f2123;
      .prodet-boxd-a {
        float: left;
        width: 336px;
        height: 500px;
        padding: 12px 0 11px 0;
      }
      .prodet-boxd-b {
        width: 64px;
        height: 500px;
        float: right;
        background: #000;
        position: relative;
        .prodet-pt-a {
          position: relative;
          width: 64px;
          height: 64px;
          padding: 10px 0;
          text-align: center;
          color: #fff;
          margin-bottom: 2px;
          cursor: pointer;
          a {
            color: #fff;
          }
          i {
            width: 26px;
            height: 26px;
            padding: 2px 0;
            font-size: 22px;
          }
          p {
            font-weight: bold;
            font-size: 12px;
          }
          &:hover {
            .background-primary();
          }
          &.active {
            .background-primary();
            &:before {
              position: absolute;
              content: " ";
              border: 8px solid transparent;
              border-right: 8px solid #27a3ff;
              bottom: 25px;
              left: -16px;
            }
          }
        }
      }
    }
  }
  .prodet-action {
    padding: 16px 0;
    height: 72px;
    .prodet-box-e {
      width: 500px;
      height: 40px;
      line-height: 40px;
      span {
        .inline-block();
        cursor: pointer;
        color: #fff;
        &.active {
          color: #27a3ff;
        }
        abbr {
          margin-left: 2px;
        }
        i {
          vertical-align: -0.1em;
          margin-right: 3px;
        }
      }
    }
    .prodet-box-f {
      width: 900px;
      height: 40px;
      float: right;
      text-align: right;
      .product-buy-class {
        float: left;
        width: 480px;
        text-align: right;
        margin-right: 30px;
        span {
          width: 120px;
          height: 40px;
          border: 1px solid #fff;
          line-height: 40px;
          font-size: 16px;
          text-align: center;
          margin-right: 15px;
          border-radius: 4px;
          color: #fff;
          cursor: pointer;
          display: inline-block;
          position: relative;
          z-index: 2;
          background-color: #2f3133;
          &.selected,
          &:not(.disabled):hover {
            border-color: #ff6a00;
            color: #ff6a00;
          }
        }
        .product-buy-class-tips {
          position: absolute;
          top: -25px;
          right: 15px;
          z-index: 1;
          color: #eb5025;
          font-size: 14px;
          text-align: center;
          width: 100px;
          height: 39px;
          display: block;
          background: url("../../assets/images/mall/review-tips.png") no-repeat;
        }
      }
      .prodet-boxf-c {
        float: left;
        margin-right: 32px;
        color: #fd9801;
        font-size: 32px;
      }
      .prodet-boxf-b {
        font-size: 1.6rem;
        color: #fff;
        display: block;
        float: left;
        line-height: 40px;
        margin-right: 32px;
        text-decoration: line-through;
        margin-top: 10px;
      }
    }
  }
}

// 通用标题
.product-info-bar {
  width: 200px;
  height: 40px;
  line-height: 40px;
  background: url("../../assets/images/v3/product-detail-title.png") no-repeat
    left center;
  color: #fff;
  font-size: 20px;
  font-weight: bold;
  text-indent: 1em;
  &-en {
    position: absolute;
    top: 30px;
    right: 12px;
  }
}

// 商品详情内容
.product-detail {
  width: 800px;
  background: white;
  float: left;
  margin-top: 30px;
  margin-bottom: 30px;
  padding: 20px 30px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);

  .product-info-bar {
    margin-left: -30px;
  }
  .product-info-title {
    padding: 30px 0 10px 0;
    font-size: 22px;
    color: #414141;
  }
  .product-info-sub {
    padding: 30px 0 10px 0;
    font-size: 18px;
    color: #666;
  }
  .product-info-body {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding-bottom: 20px;
    border-bottom: 1px dashed #ddd;
    &.col1 {
      li {
        width: 100%;
      }
    }
    li {
      width: 50%;
      color: #666;
      font-size: 16px;
      display: flex;
      margin: 5px 0;
      .info-item {
        span {
          font-size: 22px;
          color: #999;
          line-height: 1;
          vertical-align: -0.1em;
        }
      }
      .info-content {
        flex: 1;
        em {
          font-style: normal;
        }
        span {
          display: inline-block;
          color: #999;
          margin-right: 10px;
        }
        & > span {
          min-width: 160px;
        }
      }
    }
  }
  .product-course-list {
    border-bottom: 1px dashed #ddd;
    dl {
      dt {
        font-weight: bold;
        color: #666;
        font-size: 16px;
      }
      dd {
        display: inline-block;
        margin-right: 20px;
        margin-top: 5px;
        margin-bottom: 20px;
        color: #666;
        font-size: 16px;
      }
    }
  }
  .product-info-textbook {
    font-size: 16px;
    border-bottom: 1px dashed #ddd;
    padding-bottom: 20px;
    .product-info-center {
      display: flex;
      flex-wrap: wrap;
    }
    .product-info-line {
      width: 100%;
      flex-shrink: 0;
      height: 1px;
      background-color: #eee;
      margin: 18px 0;
    }
    .textbook-img {
      width: 80px;
      height: 100px;
    }
    .textbook-info {
      color: #999;
      flex: 1;
      .textbook-name {
        font-size: 20px;
        color: #666;
        margin-bottom: 6px;
        .textbook-name-in {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 2;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      span {
        font-size: 16px;
        line-height: 2;
        margin-left: 8px;
        margin-right: 50px;
      }
    }
  }
  .product-info-detail {
    margin-top: 30px;
    text-align: center;
    width: 100%;
    /deep/img {
      display: inline-block;
    }
  }
}
//侧边栏
.product-sider {
  width: 370px;
  float: right;
  background: #fff;
  margin-top: 30px;
  padding: 20px 10px;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  .product-info-bar {
    margin-left: -10px;
    margin-bottom: 30px;
  }
}
//各模块容器
.study-module {
  position: relative;
  width: 1200px;
  margin: 0 auto 30px auto;
  background: #fff;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
  padding: 20px 30px;
  .product-info-bar {
    margin-left: -30px;
    margin-bottom: 20px;
  }
}

//侧边导航
.sider-nav {
  position: fixed;
  left: 100px;
  top: 260px;
  width: 120px;
  background: #333;
  box-shadow: 0 0 5px rgba(0, 0, 0, 0.6);
  z-index: 200;
  .transTime(0.3s);
  &.put-away {
    left: -128px;
    .pos {
      right: -38px;
      box-shadow: 0 0 3px rgba(0, 0, 0, 0.6);
    }
  }
  .pos {
    position: absolute;
    width: 30px;
    height: 40px;
    line-height: 40px;
    .transTime(0.3s);
    // .background-primary();
    background: #333;
    color: #fff;
    font-size: 22px;
    text-align: center;
    right: 120px;
    top: 50%;
    margin-top: -21px;
    cursor: pointer;
    box-shadow: -2px 0 3px rgba(0, 0, 0, 0.6);
  }
  .nav-item {
    position: relative;
    width: 100%;
    height: 60px;
    line-height: 60px;
    color: #fff;
    text-align: center;
    cursor: pointer;
    font-size: 16px;
    &:hover {
      .background-primary();
    }
    &.selected {
      .background-primary();
      &:after {
        position: absolute;
        content: " ";
        border: 8px solid transparent;
        border-left: 8px solid #2481fc;
        bottom: 23px;
        right: -16px;
      }
    }
  }
}
</style>
